var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-search',{attrs:{"columns":_vm.searchColumn},on:{"search":_vm.handleSearch}}),_c('com-site-list',{ref:"table",attrs:{"model":"shop","default-params":_vm.defaultParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }